import styled from "styled-components";

export const Container = styled.div`
  padding: 64px 0;

  h1 {
    max-width: 500px;
    margin: 0 auto 1.5rem;
    font-weight: 400;
    font-size: 2rem;
    position: relative;
    line-height: 2.5rem;
    padding-bottom: 1rem;
    color: var(--velotax-font-color-light);

    :after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 2px;
      width: 100px;
      background-color: var(--ant-primary-color);
    }
  }

  p {
    max-width: 500px;
    margin: 0 auto 0.3rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--velotax-font-color-light);

    span {
      cursor: pointer;
      font-weight: 500;
      color: var(--ant-primary-color);
    }
  }

  .content {
    padding: 32px;
    margin: 0 auto;
    max-width: 500px;
    border-radius: 4px;
    background-color: var(--white);
  }

  @media only screen and (max-device-width: 812px) {
    padding: 32px 0 64px;
    background-color: var(--velotax-background-color);

    h1 {
      max-width: 100%;
      font-size: 24px;
      line-height: 32px;
      margin: 0 24px 16px;
    }

    p {
      margin: 0 24px 24px;
      max-width: 100%;
    }

    .content {
      padding: 32px 24px;
      border-radius: 0;
    }
  }
`;
